module.exports = __webpack_public_path__ + "static/media/cert_143.de8582aa.jpg";